export default "__VITE_ASSET__Dx89XgAJ__"